import React from 'react'
import useTranslate from '../../hooks/useTranslate'
import { mq } from '../../utils'
import { Text } from '../Text'
import { IProps } from './index'

export const TranscriptButton = (props: IProps) => {
  const { translate } = useTranslate()

  const handleClick = () => {
    props.onClick(props.showTranscriptContentId)
  }

  return (
    <button className="transcript-button" onClick={handleClick} type="button">
      <Text size="caption">{translate('Video Transcript')}</Text>
      <style jsx>
        {`
          .transcript-button {
            display: block;
            cursor: pointer;
            color: inherit;
            text-decoration: none;
            border-bottom: 1px dotted;
            margin: 0 auto;
            margin-top: 20px;
          }
          .transcript-button:hover,
          .transcript-button:focus {
            border-bottom: 1px solid;
            outline: none;
          }
          @media (${mq.tablet}) {
            .transcript-button {
              margin: unset;
              margin-top: 20px;
            }
          }
        `}
      </style>
    </button>
  )
}
